module.exports = __webpack_public_path__ + "static/media/icon-heating.f727eb65.svg";